import React, { useState } from 'react'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import DatePicker from '@mui/lab/DatePicker'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Tooltip } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import { useStyles } from '../../HOC/SlidesStyles'
import { RootState } from '../../../reducers'
import {
  fetchCompletedData,
  fetchInboxData,
  getAssignedData,
  getCompleteData,
  getDispatchData,
  getInProgressData,
  getITAdminAssignedData,
  getITAdminCompleteData,
  getITAdminUnassignedData,
  getLabManagerCompleteData,
  getReadyForPickupData,
  getUnassignedData,
} from '../../../actions'

const SUBMIT_FILTER_STROKE_TIME = 500

export default function CustomDatagridDateRangeFilter(props: any) {
  const { item, applyValue, focusElementRef = null, handleFilter, caseView, sortField } = props
  const dispatch = useDispatch()
  const classes = useStyles()
  const dt = new Date()
  const { user, role } = useSelector((state: RootState) => state.userLogin)
  const [filterValueState, setFilterValueState] = React.useState<[string, string]>(item.value ?? '')
  const [isDisableApply, setDisableApply] = useState(true)
  const getButtonClassName = () =>
    isDisableApply ? `${classes.btn} ${classes.disableApplyBtn} ` : `${classes.btn} ${classes.enableApplyBtn}`
  /* React.useEffect(() => {
    return () => {
      clearTimeout(filterTimeout.current)
    }
  }, []) */

  React.useEffect(() => {
    const itemValue = item.value ?? [dt, dt]
    setFilterValueState(itemValue)
  }, [item.value])

  React.useEffect(() => {
    if (filterValueState[0] && filterValueState[1] && filterValueState[0] <= filterValueState[1]) {
      setDisableApply(false)
    } else {
      setDisableApply(true)
    }
  }, [filterValueState])

  const getFormattedDate = (dt) => {
    const yyyy = dt.getFullYear()
    let mm = dt.getMonth() + 1 // Months start at 0!
    let dd = dt.getDate()

    if (dd < 10) dd = '0' + dd
    if (mm < 10) mm = '0' + mm

    return yyyy + '-' + mm + '-' + dd
  }

  const updateFilterValue = async (lowerBound: string, upperBound: string) => {
    setFilterValueState([lowerBound, upperBound])
  }

  const handleUpperFilterChange = (event) => {
    const newUpperBound = event
    updateFilterValue(filterValueState[0], newUpperBound)
  }
  const handleLowerFilterChange = (event) => {
    const newLowerBound = event
    updateFilterValue(newLowerBound, filterValueState[1])
  }

  const handleSelect = async () => {
    if (filterValueState[0] && filterValueState[1] && filterValueState[0] <= filterValueState[1]) {
      setDisableApply(false)
      applyValue({ ...item, value: [filterValueState[0], filterValueState[1]] })
      if (caseView === 'ready_for_pickup' && role === 'NL_SpecimenLogistics') {
        await dispatch(
          getReadyForPickupData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: null,
            startDate: getFormattedDate(filterValueState[0]),
            endDate: getFormattedDate(filterValueState[1]),
            sortOrder: 'asc',
            pageIndex: 0,
            pageSize: 10,
            sortField: props.sortField,
          }),
        )
      } else if (caseView === 'dispatch' && role === 'NL_SpecimenLogistics') {
        await dispatch(
          getDispatchData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: null,
            startDate: getFormattedDate(filterValueState[0]),
            endDate: getFormattedDate(filterValueState[1]),
            sortOrder: 'asc',
            pageIndex: 0,
            pageSize: 10,
            sortField: props.sortField,
          }),
        )
      } else if (caseView === 'in_progress' && role === 'NL_SpecimenLogistics') {
        await dispatch(
          getInProgressData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: null,
            startDate: getFormattedDate(filterValueState[0]),
            endDate: getFormattedDate(filterValueState[1]),
            sortOrder: 'asc',
            pageIndex: 0,
            pageSize: 10,
            sortField: props.sortField,
          }),
        )
      } else if (caseView === 'completed' && role === 'NL_SpecimenLogistics') {
        await dispatch(
          getCompleteData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: null,
            startDate: getFormattedDate(filterValueState[0]),
            endDate: getFormattedDate(filterValueState[1]),
            sortOrder: 'desc',
            pageIndex: 0,
            pageSize: 10,
            sortField: props.sortField,
          }),
        )
      } else if (caseView === 'assigned' && role === 'NL_Pathologist') {
        await dispatch(
          fetchInboxData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: null,
            startDate: getFormattedDate(filterValueState[0]),
            endDate: getFormattedDate(filterValueState[1]),
            sortOrder: 'asc',
            pageIndex: 0,
            pageSize: 10,
            sortField: props.sortField,
          }),
        )
      } else if (caseView === 'completed' && role === 'NL_Pathologist') {
        await dispatch(
          fetchCompletedData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: null,
            startDate: getFormattedDate(filterValueState[0]),
            endDate: getFormattedDate(filterValueState[1]),
            sortOrder: 'desc',
            pageIndex: 0,
            pageSize: 10,
            sortField: props.sortField,
          }),
        )
      } else if (caseView === 'unassigned' && role === 'NL_LabManager') {
        await dispatch(
          getUnassignedData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: null,
            startDate: getFormattedDate(filterValueState[0]),
            endDate: getFormattedDate(filterValueState[1]),
            sortOrder: 'asc',
            sortField: sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      } else if (caseView === 'assigned' && role === 'NL_LabManager') {
        await dispatch(
          getAssignedData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: null,
            startDate: getFormattedDate(filterValueState[0]),
            endDate: getFormattedDate(filterValueState[1]),
            sortOrder: 'asc',
            sortField: sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      } else if (caseView === 'completed' && role === 'NL_LabManager') {
        await dispatch(
          getLabManagerCompleteData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: null,
            startDate: getFormattedDate(filterValueState[0]),
            endDate: getFormattedDate(filterValueState[1]),
            sortOrder: 'desc',
            sortField: sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      } else if (caseView === 'unassigned' && role === 'NL_WOMA_ADMIN') {
        await dispatch(
          getITAdminUnassignedData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: null,
            startDate: getFormattedDate(filterValueState[0]),
            endDate: getFormattedDate(filterValueState[1]),
            sortOrder: 'asc',
            sortField: props.sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      } else if (caseView === 'assigned' && role === 'NL_WOMA_ADMIN') {
        await dispatch(
          getITAdminAssignedData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: null,
            startDate: getFormattedDate(filterValueState[0]),
            endDate: getFormattedDate(filterValueState[1]),
            sortOrder: 'asc',
            sortField: props.sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      } else if (caseView === 'completed' && role === 'NL_WOMA_ADMIN') {
        await dispatch(
          getITAdminCompleteData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: null,
            startDate: getFormattedDate(filterValueState[0]),
            endDate: getFormattedDate(filterValueState[1]),
            sortOrder: 'desc',
            sortField: props.sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      }
      handleFilter({
        filterField: props.item.columnField,
        filterValue: null,
        startDate: getFormattedDate(filterValueState[0]),
        endDate: getFormattedDate(filterValueState[1]),
        sortField: props.sortField,
      })
    }
  }

  return (
    <Box
      sx={{
        display: 'inline-flex',
        flexDirection: 'row',
        alignItems: 'end',
        width: 'auto',
        padding: '0px',
        marginTop: '8px',
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label="From"
          value={filterValueState[0]}
          onChange={handleLowerFilterChange}
          renderInput={(params) => <TextField {...params} size="small" style={{ width: '165px' }} />}
        />
        <DatePicker
          label="To"
          value={filterValueState[1]}
          onChange={handleUpperFilterChange}
          renderInput={(params) => <TextField {...params} size="small" style={{ width: '165px' }} />}
          maxDate={dt}
        />
        <Tooltip title="" placement="top-start">
          <Button
            className={getButtonClassName()}
            onClick={handleSelect}
            variant="outlined"
            size="medium"
            sx={{
              color: '#797979',
              display: 'flex',
              justifyContent: 'space-around',
              width: '100px',
            }}
            startIcon={<CheckIcon />}
          >
            Apply
          </Button>
        </Tooltip>
      </LocalizationProvider>
    </Box>
  )
}
